import { render, staticRenderFns } from "./PageBlockNotFound.vue?vue&type=template&id=07d896c8&"
import script from "./PageBlockNotFound.vue?vue&type=script&lang=js&"
export * from "./PageBlockNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports